<ui2-button class="button-icon mb-1" [title]="'chart-ng-common.zoom.zoomIn' | translate" (clicked)="onZoom(ZOOM_OUT_JUMP)">
  <span class="icon icon2-x16-plus-m"></span>
</ui2-button>

<ui2-button class="button-icon mb-1" [title]="'chart-ng-common.zoom.zoomOut' | translate" (clicked)="onZoom(ZOOM_IN_JUMP)">
  <span class="icon icon2-x16-minus-m"></span>
</ui2-button>

<ui2-button class="button-icon mb-1" [title]="'chart-ng-common.zoom.resetView' | translate" (clicked)="zoomToFit(true)">
  <span class="icon icon2-x16-center"></span>
</ui2-button>
